module.exports = __webpack_public_path__ + "static/media/Федоров В.Е..f48d89e8.pdf";